// removed by extract-text-webpack-plugin
module.exports = {"ColorPicker":"ColorPicker__ColorPicker___4bzT9","Container":"ColorPicker__Container___1rCax","Tabs":"ColorPicker__Tabs___2dzdj","ColorIcon":"ColorPicker__ColorIcon___8RTRD","Tooltip":"ColorPicker__Tooltip___3elQ6","Children":"ColorPicker__Children___2b4oI"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/ColorPicker/ColorPicker.less
// module id = 1131
// module chunks = 0 1